module.exports = __webpack_public_path__ + "files/77a26109a8ab8a6017c7552240f2573c.png";